export default "__VITE_ASSET__1POgpPLg__"